export default "__VITE_ASSET__AazAIQyR__"